import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-950">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50">桔子视频</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                聚合精彩，视界无界。一站式视频聚合平台，全网热剧尽在掌握。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-background-50 text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                <a href="/category/hongtao" className="hover:text-primary-400 transition-colors duration-200">热门平台</a>
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">帮助中心</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="flex flex-col gap-3">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-primary-400 text-sm mt-0.5"></i>
                  <span className="text-sm text-foreground-400">contact@juzi.video</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-wechat-line text-primary-400 text-sm mt-0.5"></i>
                  <span className="text-sm text-foreground-400">juzivideo_official</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-primary-400 text-sm mt-0.5"></i>
                  <span className="text-sm text-foreground-400">北京市朝阳区望京科技园A座</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 桔子视频 版权所有 | 京ICP备2023XXXXXXXX号
            </p>
            <p className="text-xs text-foreground-500">
              本站内容来源于各合作平台，如有侵权请联系删除
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}